$(function() {
  let emailInput = $('#form-popup-subscribe').find('[name="EMAIL"]')
  let email = $('[data-subscribe-blocks]').find('[name="EMAIL"]').val()
  emailInput.val(email)
  emailInput.attr('readonly','readonly')

  /**
   * Нужно для отправки кода
   * Определяем тип телефон или эмейл
   */
  $('[data-confirm]').on('click', function() {
    let type = $(this).attr('data-confirm');
    $('[name=type-message]').val(type)
  })

  $('[data-close]').on('click', function() {
    $.magnificPopup.close();
  })
})
